import { createComponent } from '@carvana/merch-components';

export const LowResultWrapper = createComponent('section', {
  className:
    'bg-blue-4 flex flex-col items-center left-[-16px] my-48 py-[95px] relative text-center text-white w-[calc(100%_+_32px)] m:left-0 m:static m:w-full'
});

export const Heading = createComponent('h1', {
  className: 'font-bold mb-16 text-3xl uppercase w-[72%] m:w-full'
});

export const Subtitle = createComponent('p', {
  className: 'pb-32 px-28 tl-body-l'
});

export const SimilarResultsHeader = createComponent('div', {
  className:
    'font-bold pb-40 px-16 text-base text-center uppercase w-full m:pb-48 l:px-40'
});
